"use strict";

import { lcvParticipantsConstants } from "../_constants/lcvParticipants.constants";

export const lcvParticipantsGetJobRolesRequest = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_GET_JOB_ROLES_REQUEST,
          payload,
     };
};

export const lcvParticipantsGetJobRolesComplete = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_GET_JOB_ROLES_COMPLETE,
          payload,
     };
};

export const lcvParticipantsImportRequest = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_IMPORT_REQUEST,
          payload,
     };
};

export const lcvParticipantsImportComplete = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_IMPORT_COMPLETE,
          payload,
     };
};

export const lcvParticipantsClearImportResult = () => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_CLEAR_IMPORT_RESULT,
     };
};

export const lcvParticipantsGetImportHistoryRequest = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_GET_IMPORT_HISTORY_REQUEST,
          payload,
     };
};

export const lcvParticipantsGetImportHistoryComplete = (payload) => {
     return {
          type: lcvParticipantsConstants.LCV_PARTICIPANTS_GET_IMPORT_HISTORY_COMPLETE,
          payload,
     };
};
